import { Grid, Typography } from "@mui/material";

export const RowEffect = ({ title = "" }) => {
  return (
    <Grid
      item
      xs={12}
    >
      <Typography
        variant="h5"
        color={"secondary"}
        fontWeight={"bold"}
        sx={{
          margin: "4rem 0rem 3rem 0rem",
          paddingY: ".1rem",
          textAlign: "center",
          boxShadow: "0.5em 0.5em rgba(140, 93, 177, 0.13), 0.5em 0.5em  .4em rgba(47, 45, 52, 0.33)",
        }}
      >
        {title}
      </Typography>
    </Grid>
  );
};
